import { useState, useEffect } from 'react'

const siteTypeIcons = {
  type_group_shelter: { icon: 'fa-solid fa-people-roof' },
  type_lodge: { icon: 'fa-solid fa-cabin' },
  type_meeting_room: { icon: 'fa-solid fa-users-between-lines' },
}

const useSiteTypeIcon = siteType => {
  const [img, setImg] = useState('')
  const { icon } = siteTypeIcons[siteType] || {}

  const getImg = type => !icon && import(`Checkout/Images/Icons/${type}.svg`)

  useEffect(() => {
    let isMounted = true
    const loadIcon = async () => {
      if (icon) return

      const response = await getImg(siteType)
      if (isMounted) setImg(response.default)
    }

    if (siteType) loadIcon()

    return () => { isMounted = false }
  }, [siteType])

  return { icon, img }
}

export default useSiteTypeIcon
